import React, {Component} from 'react';
import './LogInComponent.less';
import {FormInput, Checkbox} from '@homeaway/react-form-components';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import aamClient from '../../util/aamClient';
import {TrackingContext} from '@homeaway/react-event-tracking';

const validate = require('validate.js');

class LogInComponent extends Component {
    static get defaultProps() {
        return {
            isEmailEditable: false
        };
    }
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            password: '',
            loggedIn: false,
            errorMsg: '',
            resetPassword: false,
            rememberMe: false,
            disableLogin: false,
            errorEmailMsg: ''
        };
    }

    componentDidMount = () => {
        this.context.trigger('generic.event', {eventaction: 'login.visible', eventcategory: 'lex', eventlabel: 'ums'});
    };

    handleSubmit = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };

    validateEmail() {
        this.setState({errorEmailMsg: ''});
        let constraints = {
            from: {
                email: true
            }
        };
        let emailAddress = this.state.emailAddress.trim();
        let emailValid = !validate({from: emailAddress}, constraints);
        if (!emailValid && !this.isEmailEditable) {
            this.setState({
                errorEmailMsg: this.props.lingua.read('lex.email.invalid')
            });
        }
        return emailValid;
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    };

    handleCheck = (event) => {
        this.setState({[event.target.name]: event.target.checked});
        if (event.target.checked) {
            this.context.trigger('generic.event', {eventaction: 'rememberMe.checked', eventcategory: 'lex', eventlabel: 'ums'});
        } else {
            this.context.trigger('generic.event', {eventaction: 'rememberMe.unchecked', eventcategory: 'lex', eventlabel: 'ums'});
        }
    };

    handleError = (error, errorTitle) => {
        this.props.handleError(error, errorTitle);
    };

    edapLoginError = (error, errorTitle) => {
        this.context.trigger('login.failure', {loginsource: 'lex', logintype: 'ums'});
        if (typeof error !== 'undefined') {
            this.handleError(error, errorTitle);
        }
    };

    loginSuccess = (json) => {
        this.setState({loggedIn: true});
        this.context.trigger('login.success', {loginsource: 'lex', logintype: 'ums', publicuuid: json.publicUuid});
        this.props.setAuthJson(json);
        this.props.onClose();
    };

    checkStatus = (response) => {
        switch (response.status) {
            case 200:
                response.json().then((json) => {
                    this.loginSuccess(json);
                });
                break;
            case 401:
                this.props.disableLoading();
                this.edapLoginError();
                this.setState({errorMsg: this.props.lingua.read('lex.password.error')});
                break;
            case 403: // this is the response we get when user is locked out of account
                this.props.disableLoading();
                this.edapLoginError(this.props.lingua.read('lex.password.reset.warning'), this.props.lingua.read('lex.warning.title'));
                this.setState({resetPassword: true, errorMsg: ''});
                break;
            case 421: // this is response for forcing password reset of promoted legacy user
                this.props.updatePage('passwordresetrequest');
                break;
            case 423: // this is the response we get when blocked status of Deleted, Permanent Substandard, Spammer, Substandard, Suspicious, Fraud
                this.props.disableLoading();
                this.edapLoginError(this.props.lingua.read('error.authentication.user.blocked'), this.props.lingua.read('lex.warning.title'));
                this.setState({resetPassword: false, errorMsg: '', disableLogin: true});
                break;
            default:
                this.props.disableLoading();
                this.edapLoginError(this.props.lingua.read('error.generic'), '');
                break;
        }
    };

    editEmail = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.context.trigger('generic.event', {eventaction: 'editEmail.click', eventcategory: 'lex', eventlabel: 'ums'});
        this.props.updatePage('initial');
    };

    buttonClicked = () => {
        this.props.enableLoading();
        if (this.state.resetPassword === true) {
            setTimeout(() => {
                this.resetPassword();
            }, 800);
        } else if (this.validateEmail()) {
            setTimeout(() => {
                this.submitForm();
            }, 800);
        } else {
            this.props.disableLoading();
        }
    };

    submitForm = () => {
        this.context.trigger('login.attempt', {loginsource: 'lex', logintype: 'ums'});
        let payload = {
            userName: this.state.emailAddress,
            secret: this.state.password,
            authType: 'HOMEAWAY',
            rememberMe: this.state.rememberMe
        };
        aamClient.authenticate(payload).then(this.checkStatus);
    };

    resetPassword = () => {
        const body = {
            'emailAddress': this.state.emailAddress,
            serviceUrl: this.props.service
        };

        aamClient.passwordReset(body).then((response) => {
            if (response.status === 204) {
                this.props.updatePage('passwordreset');
                this.context.trigger('generic.event', {
                    eventaction: 'passwordreset.email.sent',
                    eventcategory: 'passwordreset',
                    eventlabel: 'ums'
                });
            } else {
                this.props.handleError(this.props.lingua.read('error.generic'), '');
                this.context.trigger('generic.event', {
                    eventaction: 'passwordreset.email.sent.error',
                    eventcategory: 'passwordreset',
                    eventvalue: `${response.status}`,
                    eventlabel: 'ums'
                });
            }
            this.props.disableLoading();
        });
    };

    getPasswordClasses = () => `form-group floating-label ${this.state.password === '' ? '' : 'not-empty'} has-feedback ${this.state.errorMsg === '' ? '' : 'has-error'}`;

    disableLoginButton = () => {
        let disableLoginButton = !this.state.password || this.state.disableLogin || !this.state.emailAddress;

        return disableLoginButton;
    }

    getPasswordContent = () => {
        let passwordFieldClasses = this.getPasswordClasses();
        let disableLoginButton = this.disableLoginButton();

        return (<div className="PasswordField">
            <div className={passwordFieldClasses}>
                <label>{this.props.lingua.read('lex.password.prompt')}</label>
                <input type={this.props.passwordType} className="password-form form-control " aria-label={this.props.lingua.read('lex.password.prompt')} id="password"
                    name="password" onChange={this.handleChange} value={this.state.password} autoComplete = "on"
                    disabled={this.state.disableLogin} autoFocus={!this.props.isEmailEditable}
                />
                <span className="PasswordShow" onClick={this.props.showHidePassword}>
                    {this.props.passwordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')}
                </span>
                <span className={this.state.errorMsg === '' ? '' : 'help-block'}>{this.state.errorMsg}</span>
            </div>
            <div className="RememberMe">
                <Checkbox
                    name="rememberMe"
                    label={this.props.lingua.read('lex.login.remember')}
                    checked={this.state.rememberMe}
                    onChange={this.handleCheck}
                    size={'sm'}
                    inline
                />
            </div>
            <ButtonPrimary id="login" name="login" type="submit" label={this.props.lingua.read('account.signin.link.text')} onClick={this.buttonClicked} disabled={disableLoginButton} className="btn-lg">
                <LoadingOverlay loading={this.props.isWaiting}/>
            </ButtonPrimary>
        </div>);
    };

    getResetPasswordContent = () => {
        let passwordFieldClasses = this.getPasswordClasses();
        return (<div className="PasswordField">
            <div className={passwordFieldClasses}>
                <label>{this.props.lingua.read('lex.password.prompt')}</label>
                <input type={this.props.passwordType} className="form-control" aria-label={this.props.lingua.read('lex.password.prompt')}
                    name="password" onChange={this.handleChange} value={this.state.password} autoComplete = "on" disabled autoFocus
                />
                <span className="PasswordDisabled" onClick={this.props.showHidePassword}>
                    {this.props.passwordType === 'input' ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')}
                </span>
            </div>
            <div className="RememberMe">
                <Checkbox
                    name="rememberMe"
                    label={this.props.lingua.read('lex.login.remember')}
                    checked={this.state.rememberMe}
                    onChange={this.handleCheck}
                    size={'sm'}
                    inline
                />
            </div>
            <ButtonPrimary type="submit" label={this.props.lingua.read('resetPassword.title')} onClick={this.buttonClicked} className="btn-lg">
                <LoadingOverlay loading={this.props.isWaiting}/>
            </ButtonPrimary>
        </div>);
    };

    render = () => {
        let emailInputClass = !this.props.isEmailEditable ? 'email-address' : '';
        let passwordFieldSetup = this.state.resetPassword === true ? this.getResetPasswordContent() : this.getPasswordContent();
        let resetPasswordLink = (this.state.resetPassword === true || this.state.disableLogin === true) ?
            null : (<ButtonLink className="Link" label={this.props.lingua.read('lex.password.forgot.link')} onClick={this.resetPassword}/>);
        return (
            <div className="LogInComponent text-center">
                <form onSubmit={this.handleSubmit} noValidate>
                    {(!this.props.multiUserEnabled && !this.props.isEmailEditable) && <a id="editEmail" onClick={this.editEmail} className="edit-email" href="">{this.props.lingua.read('lex.email.edit')}</a>}
                    <div className="EmailField">
                        <FormInput
                            id="lex-emailAddress"
                            name = "emailAddress"
                            className={emailInputClass}
                            label = {this.props.lingua.read('form.placeholder.emailAddress')}
                            value = {this.state.emailAddress}
                            onChange = {this.handleChange}
                            type= "email"
                            autoComplete = "on"
                            errorMsg={this.state.errorEmailMsg}
                            disabled={!this.props.isEmailEditable}
                            autoFocus={this.props.isEmailEditable}
                        />
                    </div>
                    {passwordFieldSetup}
                </form>
                {resetPasswordLink}
            </div>
        );
    };
}

LogInComponent.contextType = TrackingContext;
export default LogInComponent;
